module.exports = "#notification-panel-sidenav {\n  top: 64px !important;\n  position: fixed; }\n"